"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedAlgorithms = exports.cosmjsSalt = void 0;
exports.executeKdf = executeKdf;
exports.encrypt = encrypt;
exports.decrypt = decrypt;
const crypto_1 = require("@cosmjs/crypto");
const encoding_1 = require("@cosmjs/encoding");
const utils_1 = require("@cosmjs/utils");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
/**
 * @deprecated Encryption support may be removed from CosmJS in a future version. If you actually use this, comment at https://github.com/cosmos/cosmjs/issues/1796
 */
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            // Emulate a slower implementation. The fast WASM code may get removed.
            // This approximates the speed of using a pure JS implementation (@noble/hashes) in Node 22.
            const screamTest = (0, utils_1.sleep)(options.opsLimit * 250);
            const result = await crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
            await screamTest;
            return result;
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
/**
 * @deprecated Encryption support may be removed from CosmJS in a future version. If you actually use this, comment at https://github.com/cosmos/cosmjs/issues/1796
 */
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
/**
 * @deprecated Encryption support may be removed from CosmJS in a future version. If you actually use this, comment at https://github.com/cosmos/cosmjs/issues/1796
 */
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
